const CashFlowTransferType = {
	CompanyTransferToAuc: 1,
	AucTransferToInstitution: 2
};

export { CashFlowTransferType };